interface AlertDescriptor
{
	text: string;
	name: string;
	id?: string;
	classes?: string[];
}

class Alert
{

	protected element: HTMLElement;
	protected element_close: HTMLElement;

	constructor(
		descriptor: AlertDescriptor,
	)
	{
		this.element = document.createElement( 'div' );
		this.element_close = document.createElement( 'button' );

		if ( descriptor.id )
		{
			$( this.element ).attr( 'id', descriptor.id );
		}
		$( this.element ).addClass( 'alert' );

		if ( descriptor.classes )
		{
			for ( const i in descriptor.classes )
			{
				$( this.element ).addClass( 'alert-' + descriptor.classes[ i ] );
			}
		}

		$( this.element_close ).attr( 'type', 'button' );
		$( this.element_close ).addClass( 'close' );
		$( this.element_close ).attr( 'data-dismiss', 'alert' );
		$( this.element_close ).attr( 'aria-label', 'Close' );
		$( this.element_close ).html( '&times;' );

		$( this.element ).html( descriptor.text );
		$( this.element ).append( this.element_close );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
